<app-chart-wrapper [title]="'Daily Repayment vs. Disbursement'" (fullscreen)="hideFilters = $event">
    <app-chart-filter filter [form]="dailyDisbursementForm" [formControls]="dailyDisbursementFormControls" *ngIf="!hideFilters" (filter)="filterDailyRepayment($event)"></app-chart-filter>
    <app-line-chart chart></app-line-chart>
    <app-chart-summary-table table></app-chart-summary-table>
</app-chart-wrapper>